import {
    Overlay,
    Button,
    Loading,
    Uploader,
    Field,
    Tabbar,
    TabbarItem,
    Tab,
    Tabs,
    Swipe,
    SwipeItem,
    Search,
    TreeSelect,
    NavBar,
    Cell,
    CellGroup,
    Col,
    Tag,
    Image as VanImage,
    GoodsAction,
    GoodsActionButton,
    GoodsActionIcon,
    CouponCell,
    CouponList,
    Sku,
    Stepper,
    Popup,
    AddressList,
    AddressEdit,
    Notify,
    Card,
    RadioGroup,
    Radio,
    SubmitBar,
    Icon,
    Row,
    Panel,
    Toast,
    Dialog,
    Checkbox,
    List,
    DatetimePicker,
    ImagePreview,
    Progress,
    CountDown
} from 'vant'

const vant = {
    install: function (Vue) {
        Vue.use(Overlay)
        Vue.use(Button)
        Vue.use(Loading)
        Vue.use(Uploader)
        Vue.use(Field)
        Vue.use(Tabbar)
        Vue.use(TabbarItem)
        Vue.use(Tab).use(Tabs)
        Vue.use(Swipe).use(SwipeItem)
        Vue.use(Search)
        Vue.use(TreeSelect)
        Vue.use(NavBar)
        Vue.use(Cell).use(CellGroup).use(Col).use(Tag)
        Vue.use(GoodsAction).use(GoodsActionButton).use(GoodsActionIcon)
        Vue.use(VanImage)
        Vue.use(CouponCell).use(CouponList)
        Vue.use(Sku)
        Vue.use(Stepper)
        Vue.use(Popup)
        Vue.use(AddressList)
        Vue.use(AddressEdit)
        Vue.use(Notify)
        Vue.use(Card)
        Vue.use(RadioGroup)
        Vue.use(Radio);
        Vue.use(SubmitBar);
        Vue.use(Icon);
        Vue.use(Row);
        Vue.use(Panel);
        Vue.use(Toast);
        Vue.use(Dialog);
        Vue.use(Checkbox);
        Vue.use(List);
        Vue.use(DatetimePicker);
        Vue.use(ImagePreview);
        Vue.use(Progress);
        Vue.use(CountDown);
    }
}

export default vant;